/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropdailynowinners3Inputs */

const en_dropdailynowinners3 = /** @type {(inputs: Dropdailynowinners3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nobody has won yet.`)
};

const de_dropdailynowinners3 = /** @type {(inputs: Dropdailynowinners3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch niemand hat gewonnen.`)
};

/**
* | output |
* | --- |
* | "Nobody has won yet." |
*
* @param {Dropdailynowinners3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropdailynowinners3 = /** @type {((inputs?: Dropdailynowinners3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropdailynowinners3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropdailynowinners3(inputs)
	return de_dropdailynowinners3(inputs)
});
export { dropdailynowinners3 as "dropDailyNoWinners" }